/**
 * Utility functions for message operations
 */

/**
 * Finds a message in the rows data by ID
 */
export const findMessageById = (rowsData: any[], messageId: string) => {
  return rowsData.find((item: any) => item.id === messageId);
};

/**
 * Finds the index of a message in the rows data by ID
 */
export const findMessageIndexById = (rowsData: any[], messageId: string) => {
  return rowsData.findIndex((item: any) => item.id === messageId);
};

/**
 * Creates a Set with a single message ID
 */
export const createSingleSelectionSet = (messageId: string) => {
  return new Set([messageId]);
};

/**
 * Gets the next message in the list after deletion
 */
export const getNextMessageAfterDeletion = (
  rowsData: any[],
  deletedMessageId: string
) => {
  const deletedIndex = findMessageIndexById(rowsData, deletedMessageId);
  return rowsData.length >= deletedIndex + 1
    ? rowsData[deletedIndex + 1]
    : null;
};

/**
 * Common message selection logic
 */
export const selectMessage = async (
  messageId: string,
  rowsData: any[],
  actions: any,
  getEmailContent: (row: any) => Promise<any>
) => {
  const selectedRow = findMessageById(rowsData, messageId);
  if (!selectedRow) {
    actions.setSelectedDataRow(null);
    actions.setSelectedKeys(new Set());
    return null;
  }
  //console.log("selectedRow", selectedRow);
  actions.setSelectedKeys(createSingleSelectionSet(messageId));
  actions.setSelectedDataRow(selectedRow);

  const messageContent = await getEmailContent(selectedRow);
  actions.setMessageContent(messageContent);

  return selectedRow;
};
